
var id = "ticket";
var markup = "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ticket\">\n<mask id=\"ticket_mask0_72_32\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"1\" y=\"1\" width=\"14\" height=\"14\">\n<rect x=\"1.60001\" y=\"1.60001\" width=\"12.8\" height=\"12.8\" fill=\"white\" />\n</mask>\n<g mask=\"url(#ticket_mask0_72_32)\">\n<rect x=\"2.79999\" y=\"2.79999\" width=\"2.4\" height=\"2.4\" rx=\"0.4\" stroke=\"#333333\" stroke-width=\"0.8\" />\n<rect x=\"6.79999\" y=\"2.79999\" width=\"2.4\" height=\"2.4\" rx=\"0.4\" stroke=\"#333333\" stroke-width=\"0.8\" />\n<rect x=\"10.8\" y=\"2.79999\" width=\"2.4\" height=\"2.4\" rx=\"0.4\" stroke=\"#333333\" stroke-width=\"0.8\" />\n<rect x=\"2.79999\" y=\"6.79999\" width=\"2.4\" height=\"2.4\" rx=\"0.4\" stroke=\"#333333\" stroke-width=\"0.8\" />\n<rect x=\"2.79999\" y=\"10.8\" width=\"2.4\" height=\"2.4\" rx=\"0.4\" stroke=\"#333333\" stroke-width=\"0.8\" />\n<rect x=\"6.79999\" y=\"6.79999\" width=\"2.4\" height=\"2.4\" rx=\"0.4\" stroke=\"#333333\" stroke-width=\"0.8\" />\n<rect x=\"6.79999\" y=\"10.8\" width=\"2.4\" height=\"2.4\" rx=\"0.4\" stroke=\"#333333\" stroke-width=\"0.8\" />\n<rect x=\"10.8\" y=\"6.79999\" width=\"2.4\" height=\"2.4\" rx=\"0.4\" stroke=\"#333333\" stroke-width=\"0.8\" />\n<rect x=\"10.8\" y=\"10.8\" width=\"2.4\" height=\"2.4\" rx=\"0.4\" stroke=\"#333333\" stroke-width=\"0.8\" />\n<rect x=\"3.2\" y=\"12\" width=\"1.6\" height=\"0.8\" fill=\"#333333\" />\n<rect x=\"7.2\" y=\"12\" width=\"1.6\" height=\"0.8\" fill=\"#333333\" />\n<rect x=\"11.2\" y=\"12\" width=\"1.6\" height=\"0.8\" fill=\"#333333\" />\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
